'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SenderName(_ref) {
  var currentRole = _ref.currentRole,
      messageRole = _ref.messageRole,
      responder = _ref.responder;

  var firstName = (0, _responderGetters.getFirstName)(responder);
  var inVisitorUi = currentRole === _senderTypes.VISITOR;

  var visitorMessageInVisitorUi = inVisitorUi && messageRole === _senderTypes.VISITOR;

  if (visitorMessageInVisitorUi) {
    return null;
  }

  var nameString = firstName;

  // TODO: Use a proper name
  if (!nameString && (0, _responderGetters.getIsBot)(responder)) {
    nameString = 'HubBot';
  }

  nameString = nameString || _I18n2.default.text('conversationsUI.unknownVisitor');

  return _react2.default.createElement(
    'b',
    { className: 'm-right-1' },
    nameString
  );
}

SenderName.propTypes = {
  currentRole: _SenderTypePropType2.default.isRequired,
  messageRole: _SenderTypePropType2.default.isRequired,
  responder: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('Responder'), (0, _RecordPropType2.default)('Visitor')])
};

exports.default = SenderName;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/SenderName.js
// module id = 545
// module chunks = 2 3